module.exports = __webpack_public_path__ + "static/media/v8.da44eef9.mp4";